import type { ReactNode } from 'react'
import './WrapKontomatik.css'
import { cx } from '@/utils/cx'

interface WrapKontomatikProps {
  children: ReactNode
  touchScrollDisabled?: boolean
}

export const WrapKontomatik = (props: WrapKontomatikProps) => {
  return (
    <div className={cx('wrap-kontomatik', props.touchScrollDisabled && 'touch-scroll-disabled')}>
      {props.children}
    </div>
  )
}
